import { TranslateModule } from '@ngx-translate/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  standalone: true,
  imports: [TranslateModule, MatIconModule, MatButtonModule]
})
export class SnackbarComponent {

  public snackBarRef = inject(MatSnackBarRef<SnackbarComponent>);
  public data: { text: string, icon: boolean, dismiss: boolean, confirmMessage: string, textCenter: boolean } = inject(MAT_SNACK_BAR_DATA);

}
